import * as React from 'react';

export default class None extends React.PureComponent {
    render() {
        return <div />;
    }
}